module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content map"
  }, [_c('div', {
    ref: "gMapWrapper",
    staticClass: "map-wrapper"
  }, [(_vm.map.message !== null) ? _c('div', {
    class: 'callout callout-' + _vm.map.message.type
  }, [_c('p', [_vm._v(_vm._s(_vm.map.message.text))])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "elFilters",
    staticClass: "map-filters row"
  }, [_c('div', {
    class: _vm.mode === 'tournees' ? 'col-sm-9 col-md-8' : 'col-sm-9 col-md-8'
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('datepicker', {
    staticClass: "form-control",
    attrs: {
      "language": "fr"
    },
    on: {
      "input": function($event) {
        return _vm.search()
      }
    },
    model: {
      value: (_vm.state.map.filters.date),
      callback: function($$v) {
        _vm.$set(_vm.state.map.filters, "date", $$v)
      },
      expression: "state.map.filters.date"
    }
  })], 1), _vm._v(" "), (_vm.map.filters.mode === 'materiel' && _vm.materiels) ? _c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('label', [_vm._v("Matériel")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state.map.filters.idMateriel),
      expression: "state.map.filters.idMateriel"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.state.map.filters, "idMateriel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.filterTournee()
      }]
    }
  }, [(_vm.state.map.filters.idMateriel !== '') ? _c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Tous")]) : _vm._e(), _vm._v(" "), (_vm.state.map.filters.idMateriel === '') ? _c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": ''
    }
  }, [_vm._v("Tous")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.state.materiels.dataTournees), function(mat) {
    return (_vm.state.materiels.actif) ? _c('option', {
      domProps: {
        "value": mat.id
      }
    }, [_vm._v("\n                " + _vm._s(mat.nom) + "\n              ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.state.materiels.dataRemontees), function(mat) {
    return (!_vm.state.materiels.actif) ? _c('option', {
      domProps: {
        "value": mat.id
      }
    }, [_vm._v("\n                " + _vm._s(mat.nom) + "\n              ")]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.map.filters.mode === 'anomalie' && _vm.anomalieList) ? _c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('label', [_vm._v("Anomalies")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.map.filters.idAnomalie),
      expression: "map.filters.idAnomalie"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.map.filters, "idAnomalie", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Toutes")]), _vm._v(" "), _vm._l((_vm.anomalieList), function(item, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.map.filters.mode === 'anomalie' && _vm.sacList) ? _c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('label', [_vm._v("Sacs")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.map.filters.idSac),
      expression: "map.filters.idSac"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.map.filters, "idSac", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Tous")]), _vm._v(" "), _vm._l((_vm.sacList), function(item, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.map.filters.mode === 'anomalie' && _vm.evenementList) ? _c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('label', [_vm._v("Evenements")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.map.filters.idEvenement),
      expression: "map.filters.idEvenement"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.map.filters, "idEvenement", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Tous")]), _vm._v(" "), _vm._l((_vm.evenementList), function(item, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.map.filters.mode === 'anomalie') ? _c('div', {
    staticClass: "form-group col-sm-3",
    staticStyle: {
      "margin-left": "1%"
    }
  }, [_c('toggle-button', {
    attrs: {
      "value": this.$store.state.map.filters.filterPhoto,
      "sync": true,
      "labels": {
        checked: 'Avec Photo',
        unchecked: 'Avec Photo'
      },
      "color": {
        checked: '#AADC14',
        unchecked: '#767C97'
      },
      "height": 35,
      "width": 120
    },
    on: {
      "change": _vm.filterPhoto
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.state.materiels.actif) ? _c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('toggle-button', {
    attrs: {
      "value": this.$store.state.map.filters.infoWindows,
      "sync": true,
      "labels": {
        checked: 'Infobulles',
        unchecked: 'Infobulles'
      },
      "color": {
        checked: '#AADC14',
        unchecked: '#767C97'
      },
      "height": 35,
      "width": 120
    },
    on: {
      "change": _vm.toggleInfowWindows
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.state.materiels.actif) ? _c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('toggle-button', {
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'Remontées',
        unchecked: 'Tournées'
      },
      "color": {
        checked: '#AADC14',
        unchecked: '#767C97'
      },
      "height": 35,
      "width": 120
    },
    on: {
      "change": _vm.switchToTournee
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.map.filters.mode === 'materiel' && _vm.state.materiels.actif) ? _c('div', {
    staticClass: "buttons col-sm-3"
  }, [_c('label', {
    staticClass: "btn btn-default display-map",
    staticStyle: {
      "pointer-events": "none",
      "background-color": "#AADC14",
      "color": "#001051",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              " + _vm._s((_vm.state.map.result && _vm.state.map.result.dataTournees) ? ((_vm.state.map.result.dataTournees.length) + " tournée" + ((_vm.state.map.result.dataTournees.length > 1) ? 's' : '')) : "Aucune tournée") + "\n            ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-2",
    class: _vm.mode == 'tournees' ? 'col-md-offset-2' : 'col-md-offset-2'
  }, [_c('div', {
    staticClass: "switch clearfix",
    class: _vm.map.filters.mode,
    on: {
      "click": function($event) {
        return _vm.switchMode()
      }
    }
  }, [_c('div', {
    staticClass: "materiel"
  }), _vm._v(" "), _c('div', {
    staticClass: "anomalie"
  })])])]), _vm._v(" "), (!_vm.state.materiels.actif && _vm.state.map.filters.mode === 'materiel') ? _c('div', {
    staticClass: "info-tournee"
  }, [_c('div', {
    staticClass: "materiel"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Materiel")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("materielTypeV2")(_vm.state.map.infoTournee.idMateriel)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.state.map.infoTournee.nomMateriel))])]), _vm._v(" "), _c('div', {
    staticClass: "cantonnier"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Cantonnier associé")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.state.map.infoTournee.cantonnier))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Durée du service")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.state.map.infoTournee.duree) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (this.$store.state.map.filters.mode === 'anomalie') ? _c('div', [(_vm.mounted) ? _c('gmap-map', {
    ref: "map",
    staticClass: "gMap",
    class: _vm.mode,
    style: (_vm.mapStyle),
    attrs: {
      "center": _vm.center,
      "zoom": 13,
      "map-type-id": "roadmap",
      "options": {
        mapTypeControl: false
      }
    }
  }, [_c('gmap-cluster', _vm._l((_vm.state.map.result.declarations), function(d, i) {
    return (_vm.filterAnomalies(d)) ? _c('gmap-marker', {
      key: i,
      attrs: {
        "icon": {
          'url': 'static/img/' + _vm.getPictoForDeclarations(d) + '.svg'
        },
        "position": {
          'lat': d.lat,
          'lng': d.lon
        },
        "clickable": true,
        "show": true
      },
      on: {
        "click": function($event) {
          return _vm.markerClick(d)
        },
        "mouseover": function($event) {
          return _vm.peakInfowindow()
        },
        "mouseout": function($event) {
          return _vm.showInfowindow(d)
        }
      }
    }, [_c('gmap-info-window', {
      attrs: {
        "opened": d.opened && _vm.map.filters.infoWindows
      },
      on: {
        "closeclick": function($event) {
          return _vm.onInfowindowclose(d)
        }
      }
    }, [(!_vm.showPhotos) ? _c('div', {
      staticClass: "evenement ANOMALIE"
    }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("getMaterielFromDeclaration")(d.tournee_id)) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                  " + _vm._s(_vm._f("evenementType")(d)) + "\n                  "), (d.photos.length > 0) ? _c('img', {
      staticClass: "photo",
      attrs: {
        "src": "static/img/btn_photo.svg",
        "alt": "Smiley"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showPhotosPopup()
        }
      }
    }) : _vm._e()]), _vm._v(" "), (d.nature === 'EVENEMENT') ? _c('strong', [_vm._v("\n                  " + _vm._s(d.commentaire) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v("à " + _vm._s(_vm._f("prettyTimeStamp")(d.recordedAt)))]), _vm._v(" "), (d.qr_code) ? _c('div', {
      staticClass: "qr-code"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("QR Code")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(d.qr_code))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showPhotos) ? _c('div', {
      staticClass: "photos"
    }, _vm._l((d.photos), function(photo, i) {
      return _c('ul', {
        staticClass: "photos-list"
      }, [_c('li', [_c('router-link', {
        attrs: {
          "to": 'photo/' + photo.id,
          "target": "_blank"
        }
      }, [_vm._v("Photo " + _vm._s(i + 1) + "\n                    ")])], 1)])
    }), 0) : _vm._e()])], 1) : _vm._e()
  }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.$store.state.map.filters.mode === 'materiel') ? _c('div', [(_vm.mounted) ? _c('gmap-map', {
    ref: "map",
    staticClass: "gMap",
    class: _vm.mode,
    style: (_vm.mapStyle),
    attrs: {
      "center": _vm.center,
      "zoom": 13,
      "map-type-id": "roadmap",
      "options": {
        mapTypeControl: false
      }
    }
  }, [_vm._l((_vm.map.result.tournees), function(t, i) {
    return (_vm.map.result !== null && _vm.map.result.tournees && _vm.map.result.tournees.length > 0) ? _c('gmap-marker', {
      key: i,
      attrs: {
        "icon": {
          'url': 'static/img/debut_de_service.svg'
        },
        "position": {
          'lat': t.latLastRemontee,
          'lng': t.lonLastRemontee
        },
        "clickable": true,
        "show": false
      }
    }, [(_vm.mode === 'tournees') ? _c('gmap-info-window', {
      attrs: {
        "opened": _vm.map.filters.infoWindows,
        "options": {
          pixelOffset: {
            height: -5,
            width: 0
          }
        }
      }
    }, [_c('div', {
      staticClass: "pointer"
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.setMateriel(t)
        }
      }
    }, [_c('img', {
      staticClass: "top",
      attrs: {
        "src": _vm._f("materielPictoV2")(t.materiel_id),
        "alt": _vm._f("materielTypeV2")(t.materiel_id)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm._f("materielTypeV2")(t.materiel_id)))]), _vm._v("\n                " + _vm._s(_vm._f("materielName")(t.materiel_id)) + "\n                "), _c('div', {
      staticClass: "time"
    }, [(t.statusTournee === 'TERMINEE') ? _c('span', [_vm._v("Terminée à " + _vm._s(_vm._f("prettyDate")(t.endedAt)))]) : _vm._e(), _vm._v(" "), (t.statusTournee === 'EN COURS') ? _c('span', [_vm._v("En cours")]) : _vm._e()])])])]) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.state.map.result.remontees), function(r, i) {
    return (_vm.map.result !== null && _vm.state.map.result.remontees && _vm.state.map.result.remontees.length > 0) ? _c('gmap-marker', {
      key: i,
      attrs: {
        "icon": {
          'url': 'static/img/' + _vm.getPictoForRomontees(r) + '.svg'
        },
        "position": {
          'lat': r.lat,
          'lng': r.lon
        },
        "clickable": false,
        "show": false
      }
    }) : _vm._e()
  })], 2) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-179637e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Map.vue
// module id = 2086
// module chunks = 2